import React from 'react';
import styled from 'styled-components/native';
import SkeletonPlaceholder from '../skeletonPlaceholder';
import useResponsiveDimensions from '../../utils/hooks/useResponsiveDimensions';

const Container = styled.View`
  width: 100%;
  align-items: center;
`;
const Row = styled.View`
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

const SearchListSkeleton = ({
  isTwoColumn,
  isSmall,
  height,
  extraSmall,
  borderRadius = 10,
  marginBottom,
  numberOfItems = 4,
  style,
}: {
  isTwoColumn?: boolean;
  isSmall?: boolean;
  extraSmall?: boolean;
  borderRadius?: number;
  marginBottom?: number | string;
  numberOfItems?: number;
  style?: any;
  height?: number;
}) => {
  const {hdp, wdp, getByScreenSize} = useResponsiveDimensions();
  return (
    <Container style={style}>
      {isTwoColumn ? (
        <>
          {[0, 1, 2, 3, 4, 5, 6, 7].map(item => (
            <Row
              style={{
                width: wdp(94),
                marginBottom: wdp(3),
              }}
              key={item}>
              <SkeletonPlaceholder
                width={wdp(45)}
                height={wdp(45) / getByScreenSize(3, 4)}
                borderRadius={borderRadius}
              />
              <SkeletonPlaceholder
                width={wdp(45)}
                height={wdp(45) / getByScreenSize(3, 4)}
                borderRadius={borderRadius}
              />
            </Row>
          ))}
        </>
      ) : (
        <>
          {Array(numberOfItems)
            .fill(0)
            .map((_, i) => i)
            .map(item => (
              <SkeletonPlaceholder
                key={item}
                width={'100%'}
                height={height || hdp(getByScreenSize(12, 13))}
                borderRadius={borderRadius}
                marginBottom={marginBottom || (extraSmall ? '3%' : '4%')}
              />
            ))}
        </>
      )}
    </Container>
  );
};

export default SearchListSkeleton;
